<div class="radio-button-container" [class.has-error]="touched && required && !value">
  <label *ngIf="label" [for]="id || name" class="radio-button-label">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <div class="radio-options" [ngClass]="'layout-' + layout">
    <div
      *ngFor="let option of options; let i = index"
      class="radio-option"
      [ngClass]="{
        selected: isOptionSelected(option),
        disabled: isOptionDisabled(option)
      }"
      (click)="!isOptionDisabled(option) && onRadioChange(option.id)"
      (blur)="onBlur()"
    >
      <div class="radio-input-wrapper">
        <input
          type="radio"
          [id]="(id || name) + '_' + i"
          [name]="name"
          [value]="option.id"
          [checked]="isOptionSelected(option)"
          [disabled]="isOptionDisabled(option)"
          (change)="onRadioChange(option.id)"
          class="radio-input"
        />
        <div class="radio-custom radio-circle"></div>
      </div>

      <div class="radio-content">
        <label [for]="(id || name) + '_' + i" class="option-label">
          {{ option.text }}
        </label>
        <p *ngIf="showDescriptions && option.description" class="option-description">
          {{ option.description }}
        </p>
      </div>
    </div>
  </div>

  <div *ngIf="touched && required && !value" class="error-message">Please select an option.</div>

  
</div>
